import { createFileRoute } from "@tanstack/react-router"
import { CompaniesPage } from "./-Companies"

export const Route = createFileRoute("/_auth/companies/")({
  component: CompaniesPage,
})
